import React from "react"
import Link from "gatsby-link"
import SVGInline from 'react-svg-inline'
import ArticleListItem from '../components/articleListItem'
import * as PropTypes from "prop-types"
// import lozad from '../../node_modules/lozad'
import Helmet from "react-helmet";

import heroImage from "../../static/img/blocuri-aministrare-imobile-nicad.png"

import servicesIcons from "../../static/img/documente-administrare-imobile.jpg"
import mapIcon from "../../static/img/harta-prestari-servicii-administrare-imobile.svg"


const propTypes = {
  data: PropTypes.object.isRequired,
};




class IndexPage extends React.Component {
  // componentDidMount() {
  //   const observer = lozad('.lozad', {
  //     rootMargin: '10px 0px', // syntax similar to that of CSS Margin
  //     threshold: 0.1 // ratio of element convergence
  //   });
  //   observer.observe();
  // }
  render() {
    const data = this.props.data.allContentfulArticle.edges;

    function dmyOrdD(a,b){ return myDate(b) - myDate(a);}
    function myDate(s){var a=s.split(/-|\//); return new Date(a[2],a[1]-1,a[0]);}

    data.sort(function(a,b) {
      return new Date(b.node.date) - new Date(a.node.date);
    });

    const articles = data.slice(0, 3);

    return (
      <div>

        <div className="c-hero">
          <div className="c-hero__stripe c-hero__stripe--1"></div>
          <div className="c-hero__stripe c-hero__stripe--2"></div>
          <div className="o-container o-container--large c-hero__container">


            <div className="c-hero__content">
              <h1 className="c-hero__h1">Administram imobile si ansambluri rezidentiale.</h1>
              <p className="c-hero__p">Oferim management adaptat cerintelor dumneavoastra si necesitatilor imobilului in care locuiti.</p>
              <Link
                onClick={e => {
                  ga('send', 'event', { eventCategory: 'Homepage CTA new', eventAction: 'Button click', eventLabel: 'Vezi lista preturi'});
                }}
                to="/servicii/"
                className="c-button"
              >
                Descopera serviciile noastre
              </Link>
            </div>
            <img className="c-hero__img" src={heroImage} alt="Complex blocuri - administrare imobile"/>
          </div>
        </div>

        <section className="u-pv-20 u-pv-40@tablet u-bg-white">
          <div className="o-container">
            <div className="o-layout o-layout--center o-layout--gutter-20">
              <div className="o-layout__item u-1/1 u-1/2@tablet p-home__services-img">
                <img src={servicesIcons} alt="documente administrare imobile"/>
              </div>
              <div className="o-layout__item u-1/1 u-1/2@tablet">
                <h2 className="c-section-h2">Servicii administrare imobile</h2>
                {/*<p>Misiunea de a optimiza cheltuielile, de a diminua si elimina pierderile, toate acestea printr-un management performant al proprietatii.</p>*/}
                <p>Venim in intampinarea dumneavoastra cu servicii de inalta calitate, adaptate standardelor actuale de profil, oferind astfel transparenta cheltuielilor, solutii pentru diminuarea/eliminarea pierderilor, solutii pentru a asigura proprietarilor conditii maxime de confort.</p>
                <p className="u-color-grey-500">Va punem la dispozitie următoarele:</p>
                <ul className="u-mb-0 o-list-05">
                  <li><Link className="c-link-simple" to="/servicii/infiintare-asociatie-proprietari/">Servicii infiintare asociatii de proprietari</Link></li>
                  <li><Link className="c-link-simple" to="/servicii/administrare-financiara/">Servicii financiar-contabile</Link></li>
                  <li><Link className="c-link-simple" to="/servicii/plata-numerar/">Servicii plata numerar</Link></li>
                  <li><Link className="c-link-simple" to="/servicii/administrare-tehnica/">Servicii administrare tehnica</Link></li>
                  <li><Link className="c-link-simple" to="/servicii/cenzorat/">Servicii de cenzorat</Link></li>
                  <li><Link className="c-link-simple" to="/servicii/management-proiect/">Servicii de management de proiect</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="u-pv-20 u-pv-40@tablet c-section-gradient">
          <div className="o-container u-text-center@tablet">
            <h2 className="c-section-h2">Suport pentru infiintarea asociatilor de proprietari</h2>
            <div className="o-container o-container--text u-ph-0 u-mb-30">
              <p>Oferim suport pentru infiintarea asociatiilor de proprietari, preluarea tuturor facturilor de la dezvoltator si administrarea ulterioara a condominiului. </p>
            </div>
            <Link to="/servicii/infiintare-asociatie-proprietari/" className="c-button">VEZI SERVICII INFIINTARE ASOCIATIE PROPRIETARI</Link>
          </div>
        </section>


        <section className="u-pv-20 u-pv-40@tablet u-bg-white">
          <div className="o-container">
            <div className="o-layout o-layout--center o-layout--gutter-20">
              <div className="o-layout__item u-1/1 u-1/2@tablet">
                <h2 className="c-section-h2">Zona vizata de noi cuprinde</h2>
                <div className="o-layout">
                  <ul className="u-mr-30 u-mb-0">
                    <li>Arena Nationala</li>
                    <li>Aviatiei</li>
                    <li>Primaverii</li>
                    <li>Dorobanti</li>
                    <li>Cotroceni</li>
                    <li>Universitate</li>
                    <li>Romana</li>
                    <li>Unirii</li>
                    <li>Muncii</li>
                  </ul>
                  <ul>
                    <li>Pantelimon</li>
                    <li>Salajan</li>
                    <li>Trapezului</li>
                    <li>Dristor</li>
                    <li>Vitan</li>
                    <li>Timpuri noi</li>
                    <li>Tineretului</li>
                    <li>Tei</li>
                  </ul>
                </div>
              </div>
              <div className="o-layout__item u-1/1 u-1/2@tablet p-home__locations-img">
                <img src={mapIcon} alt="Harta prestari servicii administrare imobile"/>
              </div>
            </div>
          </div>
        </section>


        <section className="u-pv-20 u-pv-40@tablet c-section-gradient">
          <div className="o-container u-text-center@tablet">
            <h2 className="c-section-h2">Oferta personalizata</h2>
            <div className="o-container o-container--text u-ph-0 u-mb-30">
              <p>Personalizam oferta noastra de administrare functie de fiecare imobil in parte si de solicitarile proprietarilor din imobil. Activitatea noastră este bazată pe transparenţă, profesionalism şi responsabilitate.</p>
            </div>
            <Link to="/preturi/" className="c-button">SOLICITA O OFERTA PERSONALIZATA</Link>
          </div>
        </section>


        <section className="u-pv-20 u-pv-40@tablet">
          <div className="o-container o-container--text">
            <h2 className="c-section-h2 u-text-center@tablet u-mb-20 u-mb-30@tablet">Ultimele articole</h2>
            {articles.map(({ node }, i) => <ArticleListItem node={node} key={node.id} />)}
          </div>
        </section>
      </div>
    )
  }
}

IndexPage.propTypes = propTypes;

export default IndexPage

export const pageQuery = graphql`
  query IndexPageQuery {
    allContentfulArticle {
      edges {
        node {
          id
          slug
          title
          date
          excerpt
          cover {
            title
            resolutions(width: 680, height: 300) {
              ...GatsbyContentfulResolutions_noBase64
            }
          }
          tags {
            slug
            name
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js